<img
  *ngIf="imagePath && imagePath !== '0'; else noImage"
  [src]="imagePath"
  alt=""
  class="aligncenter"
  width="18"
  height="18" />
<ng-template #noImage> &nbsp; </ng-template>
